import { useRouter } from 'next/router';
import PageLayout from '../../../components/Page/layout';
import CategoriesTabs from '../../../components/TemplatesPage/CategoriesTabs';
import CategoryResults from '../../../components/TemplatesPage/CategoryResults';

import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/analytics';

import { useEffect, useState } from 'react';
import UpgradePlanModal from '../../../components/Plans/UpgradePlanModal';
import Button from '../../../components/Button';
import { XIcon } from '@heroicons/react/solid';
import LogInModal from '../../../components/NewModals/log-in';
import { getBillingPeriod } from '../../../utils/helpers';

export const getStaticProps = async ({ params: { type } }) => {
  try {
    const firebaseConfig = {
      apiKey: 'AIzaSyA64Cm0bTMY9Rinvha_z3ENAUhkJssFCO8',
      authDomain: 'auth.typeshare.co',
      projectId: 'typeshare-2027d',
      storageBucket: 'typeshare-2027d.appspot.com',
      databaseURL: 'https://typeshare-2027d-default-rtdb.firebaseio.com/',
      messagingSenderId: '305996917305',
      appId: '1:305996917305:web:704a11e8f876840e87bbe8',
      measurementId: 'G-LX68JP4ZZK',
    };

    //TEST APP

    const firebaseConfigStaging = {
      apiKey: 'AIzaSyD5pDmQa1lIAYiW1qd7Swez2gaXG-ggWtc',
      authDomain: 'test-88a5a.firebaseapp.com',
      projectId: 'test-88a5a',
      storageBucket: 'test-88a5a.appspot.com',
      messagingSenderId: '952460692987',
      appId: '1:952460692987:web:0b0eb7f65c0e3f6767cf5e',
    };

    if (process.env.NEXT_PUBLIC_APP_ENV === 'production') {
      if (firebase.apps.length === 0) {
        firebase.initializeApp(firebaseConfig);
      }
    } else {
      if (firebase.apps.length === 0) {
        firebase.initializeApp(firebaseConfigStaging);
      }
    }

    const baseRef = firebase.database().ref('templates2');
    const activeType = await baseRef.child('types').child(type).once('value');

    const templateIDs = Object.keys(activeType.val().templates);

    const templates = await Promise.all(
      templateIDs.map(async (templateID) => {
        const ref = baseRef.child('templates').child(templateID).child('meta');
        const snapshot = await ref.once('value');
        var format = {
          meta: snapshot.val(),
        };
        return format;
      }),
    );

    //get creator's name and photo from firebase and update templates
    const creators = await Promise.all(
      templates.map(async (template) => {
        const ref = baseRef.child('creators').child(template.meta.creator);
        const snapshot = await ref.once('value');
        return snapshot.val();
      }),
    );

    templates.forEach((template, index) => {
      template.meta.creator_name = creators[index].name;
      template.meta.creator_photo = creators[index].photo;
    });

    return {
      props: {
        exists: true,
        activeType: activeType.val(),
        templates: templates,
        STRIPE_PK: process.env.STRIPE_PK,
      },
      revalidate: 1,
    };
  } catch (error) {
    console.log(error);

    return {
      props: {
        exists: false,
        STRIPE_PK: process.env.STRIPE_PK,
      },
      revalidate: 1,
    };
  }
};

export async function getStaticPaths() {
  return {
    paths: [
      { params: { type: 'atomic-essay' } },
      { params: { type: 'tweet' } },
      { params: { type: 'thread' } },
      { params: { type: 'linkedin-post' } },
      { params: { type: 'subatomic-essay' } },
    ],
    fallback: 'blocking',
  };
}

export default function TemplatesType({
  activeType,
  exists,
  templates,
  STRIPE_PK,
}) {
  const router = useRouter();
  const { type } = router.query;

  const [unlockedPacks, setUnlockedPacks] = useState(null);
  const [userID, setUserID] = useState(null);
  const [productName, setProductName] = useState('Free Plan');

  const [onboarding, setOnboarding] = useState(false);

  const [upgradeModalOpen, setUpgradeModalOpen] = useState(false);

  useEffect(() => {
    firebase.auth().onAuthStateChanged(function (userInfo) {
      if (userInfo) {
        setUserID(firebase.auth().currentUser.uid);
        getActiveProduct(firebase.auth().currentUser.uid);
      } else {
      }
    });
  }, []);

  useEffect(() => {
    userID && getSchedule(userID);
  }, [userID]);

  useEffect(() => {
    if (userID && onboarding) {
      setOnboarding(false);
    }
  }, [userID]);

  async function getActiveProduct(userID) {
    var ref = firebase.database().ref('users/' + userID + '/plan');
    ref.on(
      'value',
      async function (snapshot) {
        if (snapshot.hasChild('productName')) {
          var c = snapshot.hasChild('confirmed');

          if (
            snapshot.val().productName.includes('Pro') ||
            snapshot.val().productName.includes('pro') ||
            snapshot.val().productName.includes('Expert')
          ) {
            //check the period
            if (snapshot.val().productName === 'Expert Lifetime') {
              setProductName('Premier');
            } else {
              if (snapshot.hasChild('stripe/subscriptionID')) {
                getBillingPeriod(
                  snapshot.val().stripe.subscriptionID,
                  snapshot.val().productName,
                );
              } else {
                setProductName(snapshot.val().productName);
              }
            }
          } else {
            setProductName(snapshot.val().productName);
          }
        } else {
          setProductName('Free Plan');
        }
      },
      function (errorObject) {},
    );
  }

  const getSchedule = async (userID) => {
    var tmpUnlockedPacks = {};

    var ref = await firebase
      .database()
      .ref('users/' + userID)
      .child('templatePackSchedule')
      .child('edition-1')
      .once('value');
    tmpUnlockedPacks = ref.val();

    var ref2 = await firebase
      .database()
      .ref('users/' + userID)
      .child('templatePackSchedule')
      .child('oneTime')
      .once('value');
    tmpUnlockedPacks = { ...tmpUnlockedPacks, ...ref2.val() };

    setUnlockedPacks(tmpUnlockedPacks);
  };

  async function incrementCount(slug, pack) {
    try {
      await client.post('/api/templates/increment', { slug, pack });
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  const createTypeshare = async (templateMeta) => {
    if (!userID) {
      // setLoginModalOpen(true)
    } else {
      const slug = templateMeta.meta.slug;

      const templateRef = await firebase
        .database()
        .ref('templates2')
        .child('templates')
        .child(slug)
        .once('value');
      const template = templateRef.val();

      const metaTitle = template.meta.title;
      const data = template.data;
      const pack = template.meta?.pack ? template.meta.pack : null;

      firebase
        .analytics()
        .logEvent('create_typeshare', { type: 'template', name: metaTitle });
      await incrementCount(slug, pack);

      firebase
        .database()
        .ref('users/' + userID + '/typeshares/')
        .push(data)
        .then((snap) => {
          firebase
            .database()
            .ref('users/' + userID + '/typeshares/')
            .child(snap.key)
            .update({
              timestamp: {
                unix: new Date().getTime(),
              },
            })
            .then(() => {
              router.push({
                pathname: '/editor/[pid]',
                query: { pid: snap.key },
              });
            });
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const createBlankTypeshare = async (type) => {
    if (!userID) {
      // setLoginModalOpen(true)
    } else {
      firebase.analytics().logEvent('create_typeshare', { type: 'blank' });

      firebase
        .database()
        .ref('users/' + userID + '/typeshares')
        .push({
          content: {
            V2Editor: true,
            bodyText: '',
            titleText: '',
          },
        })
        .then((snap) => {
          firebase
            .database()
            .ref('users/' + userID + '/typeshares/')
            .child(snap.key)
            .update({
              timestamp: {
                unix: new Date().getTime(),
              },
              settings: {
                twitterFormat:
                  type === 'atomic-essay' || type === 'subatomic-essay'
                    ? 'image'
                    : 'thread',
                activePreview:
                  type === 'twitter' ||
                  type === 'atomic-essay' ||
                  type === 'subatomic-essay'
                    ? 'twitter'
                    : type === 'linkedin-post'
                    ? 'linkedin'
                    : 'twitter',
              },
            })
            .then(() => {
              router.push({
                pathname: '/editor/[pid]',
                query: { pid: snap.key },
              });
            });
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  return (
    <PageLayout
      title={
        type === 'atomic-essay'
          ? 'Atomic Essay Templates'
          : type === 'tweet'
          ? 'Tweet Templates'
          : type === 'thread'
          ? 'Thread Templates'
          : type === 'linkedin-post'
          ? 'LinkedIn Post Templates'
          : type === 'subatomic-essay'
          ? 'Subatomic Essay Templates'
          : 'Digital Writing Templates'
      }
      og={`/ogs/${
        type === 'atomic-essay'
          ? 'essays'
          : type === 'tweet'
          ? 'tweets'
          : type === 'thread'
          ? 'threads'
          : type === 'linkedin-post'
          ? 'linkedin'
          : type === 'subatomic-essay'
          ? 'subatomic'
          : 'templates'
      }.png`}
      description={
        'Browse our library of Digital Writing templates so you never have to stare at a blank page again.'
      }
    >
      <LogInModal isOpen={onboarding} setOpen={setOnboarding} closable={true} />
      <UpgradePlanModal
        isOpen={upgradeModalOpen}
        setIsOpen={setUpgradeModalOpen}
        STRIPE_PK={STRIPE_PK}
      />
      <div className="mt-7 flex flex-col space-y-8">
        <div className="flex w-full flex-col space-y-1">
          <div className="flex flex-row items-center justify-between space-y-1">
            <h1 className="text-xl font-semibold tracking-tight text-gray-800">
              Browse by Type
            </h1>
            <Button
              click={() => router.push('/templates')}
              size={'mini'}
              variant={'secondary'}
              prefix={<XIcon className={'-mr-2 h-4 w-4'} />}
            >
              Clear Filters
            </Button>
          </div>
          <CategoriesTabs />
        </div>

        <div className="flex w-full flex-col space-y-2">
          <h1 className="text-sm font-medium uppercase tracking-wide text-gray-500">
            {activeType && activeType.templates && activeType.templates.length}{' '}
            Templates
          </h1>
          <CategoryResults
            openLoginModal={() => setOnboarding(true)}
            isLoggedIn={userID}
            productName={productName}
            setPlanModalOpen={setUpgradeModalOpen}
            packUnlocks={unlockedPacks}
            createBlankTypeshare={(type) => createBlankTypeshare(type)}
            createTypeshare={(template) => createTypeshare(template)}
            data={activeType}
            templates={templates}
          />
        </div>
      </div>
    </PageLayout>
  );
}
